export class ApplicationModel {
  constructor(
    public redirectUrl: string,
    public entityId: string,
    public name: string,
    public friendlyName: string,
    public logoFile: any,
    public type: string
  ) {}

  static fromMap(map: { [key: string]: any }): ApplicationModel | null { // Accept plain object
    const entityId = map['entityId'] || '';
    const name = map['name'] || '';
    const redirectUrl = map['redirectUrl'] || '';
    const friendlyName = map['friendlyName'] || '';
    const logoFile = map['logoFile'] || null;
    const type = map['type'] || '';
    return new ApplicationModel(redirectUrl, entityId, name, friendlyName, logoFile, type);
  }

}
